import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatFormField } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FacetValues } from '../../pages/overview/models/overview';
import { UpperCasePipe } from '@angular/common';
import { SelectAllFacetsDirective } from './directives/select-all-facets.directive';

export interface EmittedFacets {
  columnKey: string;
  values: string[];
  filterKey: string;
}

@Component({
  selector: 'app-facet-filter',
  standalone: true,
  imports: [
    MatSelect,
    MatOption,
    MatFormField,
    MatButton,
    NgxMatSelectSearchModule,
    FormsModule,
    ReactiveFormsModule,
    UpperCasePipe,
    SelectAllFacetsDirective
  ],
  templateUrl: './facet-filter.component.html',
  styleUrl: './facet-filter.component.scss'
})
export class FacetFilterComponent implements OnChanges {
  @ViewChild('filterSelect') filterSelect!: MatSelect;
  @ViewChild(SelectAllFacetsDirective) selectAllDirective!: SelectAllFacetsDirective;
  @Input() filterValues: FacetValues[] | null = null;
  @Input() columnKey: string = '';
  @Output() selectedValues = new EventEmitter<EmittedFacets>();
  data: FacetValues[] = [];
  selectFormControl = new FormControl();
  numberOfAppliedFilters = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterValues'].currentValue) {
      this.data = this.filterValues!;
    }
  }

  filterOptions(searchTerm: string) {
    if (this.filterValues) {
      const normalizedSearchTerm = this.normalizeWhitespace(searchTerm);
      this.data = this.filterValues.filter(val => this.normalizeWhitespace(val.value).includes(normalizedSearchTerm));
    }
  }

  private normalizeWhitespace(value: string): string {
    return value.toLowerCase().replace(/\s+/g, ' ');
  }

  apply() {
    if (this.filteredFormValues()) {
      this.selectedValues.emit({
        columnKey: this.columnKey,
        values: this.filteredFormValues(),
        filterKey: 'equalsOneOf'
      });
      this.countFilters();
      this.filterSelect.close();
    }
  }

  clear() {
    if (this.filteredFormValues()) {
      this.selectFormControl.reset('');
      this.selectAllDirective.unselect();
      this.selectedValues.emit({ columnKey: this.columnKey, values: [], filterKey: 'equalsOneOf' });
      this.filterSelect.close();
      this.numberOfAppliedFilters = 0;
    }
  }

  private countFilters() {
    this.numberOfAppliedFilters = Array.isArray(this.filteredFormValues()) ? this.filteredFormValues().length : 0;
  }

  private filteredFormValues() {
    const formValues = this.selectFormControl.getRawValue() as string[];
    return formValues?.filter(el => el !== 'select-all');
  }
}
